import React from "react";

import { IconBinaryTree2, IconBuildingEstate, IconCircleKey, IconSwitch, IconUserCircle } from "../icons";
import { CompanyNavigationLinks } from "./types";
import { DropdownLinkItem, DropdownMenu, DropdownSeparator } from "./DropdownMenu";
import { truncateCompanyName } from "./truncateCompanyName";

export function CompanyDropdown({
  companyName,
  links,
  canViewCompanyDirectory,
}: {
  companyName: string;
  links: CompanyNavigationLinks;
  canViewCompanyDirectory: boolean;
}) {
  const displayName = truncateCompanyName(companyName);

  return (
    <DropdownMenu
      testId="company-dropdown"
      name={displayName}
      title={displayName === companyName ? undefined : companyName}
      icon={IconBuildingEstate}
      align="start"
      showDropdownIcon
    >
      <DropdownLinkItem
        path={links.people}
        icon={IconUserCircle}
        title="Люди"
        testId="company-dropdown-people"
        hidden={!canViewCompanyDirectory}
      />
      <DropdownLinkItem
        path={links.orgChart}
        icon={IconBinaryTree2}
        title="Организационная структура"
        testId="company-dropdown-org-chart"
        hidden={!canViewCompanyDirectory}
      />

      <DropdownSeparator />

      <DropdownLinkItem
        path={links.companyAdmin}
        icon={IconCircleKey}
        title="Администратор компании"
        testId="company-dropdown-company-admin"
      />
      <DropdownLinkItem path={links.lobby} icon={IconSwitch} title="Переключить компанию" testId="company-dropdown-switch" />
    </DropdownMenu>
  );
}
